var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCigarette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.836 11.634H15V11.64C13.776 11.64 12.78 10.464 12.78 9.24001C12.78 8.01601 13.776 7.14003 15 7.14003V5.34003C12.786 5.34003 10.98 7.14003 10.98 9.36004C10.98 11.5801 12.78 13.3801 15 13.3801V13.374H16.836C18.09 13.374 19.2 14.2621 19.2 15.84V17.4H21V15.426C21 13.266 19.08 11.634 16.836 11.634Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.6H19.2V22.2H21V18.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.6H0V22.2H18V18.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.22 8.67599C20.958 7.94997 21.42 6.93601 21.42 5.82001C21.42 3.59999 19.614 1.8 17.4 1.8V3.59999C18.624 3.59999 19.62 4.59601 19.62 5.82001C19.62 7.04401 18.624 8.04003 17.4 8.04003V9.84003C20.0939 9.84003 22.1999 12.03 22.1999 14.724V17.4H23.9999V14.718C24 12.048 22.464 9.74401 20.22 8.67599Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.6H22.2V22.2H24V18.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCigarette);
export default __webpack_public_path__ + "static/media/cigarette.9151f017d8a7b009b6f6418bcce71411.svg";
export { ForwardRef as ReactComponent };